import React, { useState, useEffect } from "react";
import "./UserLeftSidebar.css";
import profile from "../assets/images/profile.png";
import LogoutIcon from '@mui/icons-material/Logout';
import { NavLink, useNavigate } from "react-router-dom";//Navlink

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import PersonIcon from '@mui/icons-material/Person';

export default function UserLeftSidebar() {
  const navigate = useNavigate();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Error parsing user from localStorage:", e);
      }
    }
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div className='outerrrrr'>
      <div className="mobile-view-btn-text">
        <button className="menu-btn" onClick={() => setOpenSidebar(true)}>
          <MenuIcon />
        </button>
      </div>

      <div className={`iner-dashbord-left ${openSidebar ? "active" : ""}`}>
        <button className="close-btn" onClick={() => setOpenSidebar(false)}>
          <CloseIcon />
        </button>

        <div className='dashbord-list-section'>
          <ul>
            <li> <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")} > <HomeOutlinedIcon /> Dashboard </NavLink> </li>
            <li> <NavLink to="/manageprofile" className={({ isActive }) => (isActive ? "active" : "")}>  <PersonOutlineOutlinedIcon />Profile </NavLink> </li>
            <li> <NavLink to="/myorderDetail" className={({ isActive }) => (isActive ? "active" : "")} > <LocalMallOutlinedIcon /> My Orders </NavLink> </li>
            <li> <NavLink to="/purchasehistory" className={({ isActive }) => (isActive ? "active" : "")} > <CurrencyRupeeOutlinedIcon /> My Payments </NavLink> </li>
            <li> <NavLink to="/addressbook" className={({ isActive }) => (isActive ? "active" : "")}> <LocationOnOutlinedIcon /> Address Book </NavLink> </li>
            <li> <NavLink to="/needhelp" className={({ isActive }) => (isActive ? "active" : "")} > <HeadsetMicOutlinedIcon /> Need Help  </NavLink> </li>
            <li> <a href="/login" onClick={handleLogout}> <LogoutIcon /> Logout </a> </li>
          </ul>
        </div>

        <div className="active_member_box">
          <PersonIcon />
          <h3>{user ? `${user.user_first_name} ${user.user_last_name}` : "Guest User"}</h3>
          <p>
            {user
              ? (() => {
                  const raw = user.user_created || user.created_at || user.user_created_at || user.user_date || user.created;
                  if (!raw) return "Member";
                  try {
                    const d = new Date(raw);
                    if (isNaN(d.getTime())) return raw;
                    return `Since ${d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}`;
                  } catch (e) {
                    return raw;
                  }
                })()
              : "Welcome"}
          </p>
        </div>

      </div>
    </div>
  )
} 